import { render } from "./JIRA_BACKLOG_IMPORT_COMPLETED.vue?vue&type=template&id=72110594&ts=true"
import script from "./JIRA_BACKLOG_IMPORT_COMPLETED.vue?vue&type=script&lang=ts"
export * from "./JIRA_BACKLOG_IMPORT_COMPLETED.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__